/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {TemplateFeatureValueStates} from './TemplateFeatureValueStates';
import {FeatureValuesFilterProduct} from './FeatureValuesFilterProduct';

export interface TemplateFeatureWithValues {
  id?: number;
  header: string;
  templateId?: number;
  groupId?: number;
  featureId: number;
  featureTypeId: number;
  featureGroupId: number;
  unitId?: number;
  unitHeader?: string;
  featureTypeCode: string;
  featureTypeHeader: string;
  keyFeature?: boolean;
  multiple?: boolean;
  required?: boolean;
  isFilter?: boolean;
  sort?: number;
  units?: [];
  featureValues?: FeatureValuesFilterProduct[];
  featureValuesState?: TemplateFeatureValueStates;
  comment?: string;
}
